
import { i18nText } from '@/locales';

import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import { Component, Vue } from "vue-property-decorator";
import { Col, DatePicker, FormModel, Input, Row, Select, message, InputNumber } from "ant-design-vue";
import { mixins } from "vue-class-component";
import { StoreMix } from "@/UI/mixins/Store/StoreMix";
import { FormLayoutMix } from "@/UI/mixins/Layouts/Form";
import { OperationMoveProductData, ProductData, FormRules } from "@/form/Warehouse/Operations/MoveProductFormData";
import { SimpleProxyForm } from "@/UI/components/Helpers/SimpleProxyForm";
import { PaginationMix } from "@/UI/mixins/PaginationMix";
import { StoresStore } from "@/store/modules/Warehouse/Warehouse";
import { OperationsMoveStore } from "@/store/modules/Warehouse/OperationsMove";
import { ProductsStockMix } from "@/UI/mixins/Store/ProductsStockMix";
import { showNotification, showNotificationSimple } from "@/UI/lib/messages";
import { ProductsUnitStore } from "@/store/modules/Warehouse/ProductsUnit";
import { ProductsUnitMix } from "@/UI/mixins/Store/ProductsUnitMix";
import { ProductsStock, DataEntityStock } from "@/entity/warehouse/Products/ProductsStock.types";
import { CancelMix } from "@/UI/pages/Stores/Mixins/CancelMix";
import StockProductsDialog from "@/UI/pages/Stores/Dialogs/StockProductsDialog.vue";
import ModalWrapper from "@/UI/components/common/ModalWrapper.vue";
import { HideOnScrollMix } from "@/UI/mixins/Calendar/HideOnScrollMix";
import moment from 'moment';
import { HandleScrollStorewithParam, HandleScrollStore, SearchinStore } from "@/UI/Decorators/decorator";

@Component({
    components: {
        BaseDataForm,
        StockProductsDialog,
        ModalWrapper,

        "a-select": Select,
        "a-select-option": Select.Option,
        "a-col": Col,
        "a-row": Row,
        "a-date-picker": DatePicker,
        "a-textarea": Input.TextArea,
        "a-form-model": FormModel,
        "a-form-model-item": FormModel.Item,
        "a-input-number": InputNumber,
    },
    methods: {},
})
export default class ProductsMove extends mixins(
    SimpleProxyForm,
    FormLayoutMix,
    StoreMix,
    ProductsStockMix,
    PaginationMix,
    ProductsUnitMix,
    HideOnScrollMix,
    CancelMix,
) {
    //TODO:: Добавить в productsStore id  склада для правильного выбора товарв
    showStockProducts = false;
    form = new OperationMoveProductData();
    rules = FormRules;
    Studio_id = this.$router.currentRoute.params["Studio"];
    allowAddProduct = false;
    stockProducts: ProductsStock | null = null;
    tree_keys = [];

    selectAndAddProduct() {
        this.tree_keys.forEach((i: any, index: any) => {
            this.form.addProduct({
                id: i,
                quantity: 1
            });
        });
        this.showStockProducts = false;
    }

    onCheck(checkedKeys: any): void {
        this.tree_keys = checkedKeys;
    }

    prepareStockProducts() {
        console.log('this.stockProducts', this.stockProducts, this.$store.state.productsStock.items.data)
        this.stockProducts = this.$store.state.productsStock.items
        if (this.stockProducts && this.stockProducts.data) {
            this.stockProducts.data.forEach((item: any) => {
                //TODO::постараться реализовать в Vuex Module
                item["id"] = item["product_nomenclature_id"];
            });
        }
    }

    @HandleScrollStorewithParam
    hScroll(event: any, source: string, items: string, salon_id: any, customParams: any): void {
        this.prepareStockProducts()
    }
    handleScrollProducts(): void {
        const customParams = {
            quantity: '>0'
        };
        this.hScroll(event, "productsStock", "items", null, customParams);
    }
    handleModal(): void {
        this.showStockProducts = false;
    }

    ProductSelectChange(index: number): void {
        const data = this.getProductStockData(index);
        if (this.form && this.form.products) {
            this.form.products[index]["id"] = data["nomenclature"]["id"];
        }
    }
    changeProduct(index: number): void {
        //if (this.form.products) this.form.products[index].quantity = index;
    }
    getMaxValue(id: number): number {
        //form.products[index].id
        const data = this.getProductStockData(id);
        if (data) {
            return data["quantity"];
        } else return 0;
    }
    getProductUnit(id: number): any {
        let data = null;
        if (this.productsStocks && this.productsStocks.data && id !== 0) {
            const dta = this.getProductStockData(id);
            data = this.ProductUnit(dta["nomenclature"]["sale_unit_id"]);
        }
        if (data) return data["name"];
        else return " ";
    }
    getProductStockData(id: number): any {
        let data = null;
        if (this.productsStocks && this.productsStocks.data) {
            console.log("PROD", this.productsStocks);
            this.productsStocks.data.forEach((dta, index) => {
                if (dta["id"] === id) {
                    data = dta;
                }
            });
        }
        return data;
    }
    public deleteProduct(index: number): void {
        this.form.deleteProduct(index);
    }
    async storeChange(): Promise<void> {
        this.allowAddProduct = false;
        await this.getStockProducts(Number(this.form.store_from));
        if (this.productsStocks && this.productsStocks.data) {
            if (this.productsStocks.data.length > 0) {
                this.form.products = [];
                if (this.productsStocks.data) {
                    this.stockProducts = this.productsStocks;
                    if (this.stockProducts.data !== undefined && this.stockProducts.data) {
                        this.stockProducts.data.forEach((item: any) => {
                            //TODO::постараться реализовать в Vuex Module
                            item["id"] = item["product_nomenclature_id"];
                        });
                    }
                }
                this.form.store_to = null;
                this.allowAddProduct = true;
                showNotificationSimple(i18nText("Внимание"), i18nText("Данные готовы к операции"), 1);
            } else {
                showNotificationSimple(i18nText("Ошибка"), i18nText("нет товаров для перемещения"), 100);
            }
        }
    }
    async moveProduct(): Promise<void> {
        (this.$refs.storeOperation as FormModel).validate(async (valid) => {
            if (valid) {
                try {
                    this.form.salon_id = Number(this.Studio_id);
                    await OperationsMoveStore.create(this.form).then((response) => {
                        showNotification(i18nText("Перемещение товаров -"), response);
                    });
                } catch (e) {
                    message.error(i18nText("Ошибка складской операции -") + e);
                } finally {
                    await Vue.router.push({
                        name: String(this.$routeRules.StoreOperations),
                        params: {
                            Studio: this.Studio_id,
                        },
                    });
                }
            }
        });
    }
    public addProductsFromList(): void {
        this.showStockProducts = true;
    }
    public addProduct(obj: {}): void {
        this.form.addProduct(new ProductData());
    }
    async getData(): Promise<void> {
        await StoresStore.fetchAll({ limit: this.AppPageParams.pageSize, filter: { salon_id: this.Studio_id } });
        /*await ProductsStockStore.fetchAll({
            filter: { salon_id: this.Studio_id },
        });*/
    }
    async created(): Promise<void> {
        //this.tableLoad = false;
        this.formReady = false;
        if (!this.formReady) {
            try {
                await this.getData();
                if (!ProductsUnitStore.ready) await ProductsUnitStore.fetchAll({ filter: { salon_id: '151648' } });
                /*if (!ProductsStore.ready) await ProductsStore.fetchAll({ limit: this.AppPageParams.pageSize });
                if (!StoresStore.ready) await StoresStore.fetchAll();*/
            } catch (e) {
                console.log("Error product Move Form");
            } finally {
                await ProductsUnitStore.setReady(true);
                this.formReady = true;
            }
        }
    }
}
